module.exports = "/images/icon_ourstory_3.png?eb8506f28f8cab3538594c1da4abfff5";